export default __webpack_public_path__ + "static/media/n2.81f6953b.svg";